import React from 'react';
import PropTypes from 'prop-types';

import Headline from '../../headline/headline';
import StyledEducationNumber from './educationNumber.style';
import EducationShape from '../shape/educationShape';

const EducationNumber = ({ number, contentType, category, className = '' }) => {
  return (
    <StyledEducationNumber>
      <div className={`number ${className}`}>
        <div className="number__content-container">
          <Headline tag="span" className="number__content">
            {number}
          </Headline>
        </div>
        <EducationShape
          className="number__shape"
          clippedClass="number__clipped"
          contentType={contentType}
          category={category}
        />
      </div>
    </StyledEducationNumber>
  );
};

EducationNumber.propTypes = {
  number: PropTypes.number.isRequired,
  contentType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  category: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  className: PropTypes.string
};

export default EducationNumber;
